import { Editor as SlateEditor, Range as SlateRange, Transforms as SlateTransforms } from 'slate';
import { DOMEditor } from 'slate-dom';
import { ReactEditor } from 'slate-react';

export const focusEditorDom = (editor) => {
  const element = DOMEditor.toDOMNode(editor, editor);
  element.focus({ preventScroll: true });
};

export const blurEditorDom = (editor) => {
  const element = DOMEditor.toDOMNode(editor, editor);
  element.blur();
};

export const editorHasValidSelection = (editor) => {
  const { selection } = editor;
  return (
    selection != null &&
    !SlateRange.isCollapsed(selection) &&
    SlateEditor.string(editor, selection).length > 0
  );
};

export const editorIsFocusedAndHasValidSelection = (editor) => {
  return ReactEditor.isFocused(editor) && editorHasValidSelection(editor);
};

export const selectEditorLine = (editor) => {
  SlateTransforms.move(editor, {
    distance: 1,
    unit: 'line',
    reverse: true,
  });
  const startPoint = editor.selection.anchor;

  SlateTransforms.move(editor, {
    distance: 1,
    unit: 'line',
    reverse: false,
  });
  const endPoint = editor.selection.focus;

  SlateTransforms.select(editor, { anchor: startPoint, focus: endPoint });
};
